// ---------------------------------------------------------------------------
// Per-page tab title and description.
//
// Crawlers get their tags from the server (see server/src/modules/seo), because
// they do not run JavaScript. This keeps the *browser* in step during in-app
// navigation, so the tab title and bookmark name follow the page.
//
// Deliberately has no cleanup: whichever page mounts next sets its own title,
// and a cleanup that restored the site default could win a race against it.
// ---------------------------------------------------------------------------

import { useEffect } from 'react';

import { useSite } from '../context/SiteProvider.jsx';

const setMeta = (selector, value) => {
  if (!value) return;
  const tag = document.head.querySelector(selector);
  if (tag) tag.setAttribute('content', value);
};

/**
 * @param {string|null} title  Page name, or null while it is still loading.
 * @param {string} [description]
 */
export function usePageMeta(title, description) {
  const { settings } = useSite();

  const siteTitle = settings['seo.title'] ?? 'Connix';
  const brand = settings['brand.name'] ?? 'Connix';
  const fallbackDescription = settings['seo.description'];

  const resolved = title ? `${title} — ${brand}` : siteTitle;
  const resolvedDescription = description ?? fallbackDescription;

  useEffect(() => {
    document.title = resolved;
  }, [resolved]);

  useEffect(() => {
    setMeta('meta[name="description"]', resolvedDescription);
  }, [resolvedDescription]);
}
